var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8,
    r: 8,
    fill: "#1977F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6141 10.3129L11.9685 7.99985H9.74995V6.49908C9.74995 5.86682 10.0593 5.24918 11.0538 5.24918H12.063V3.2804C12.063 3.2804 11.1472 3.12402 10.272 3.12402C8.44493 3.12402 7.25017 4.23104 7.25017 6.23695V7.99985H5.21838V10.3129H7.25017V15.9031C7.65742 15.9672 8.0748 15.9999 8.50006 15.9999C8.92532 15.9999 9.3427 15.9661 9.74995 15.9031V10.3129H11.6141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.7c28443ad46ad1a9c014d1aa88bb7b19.svg";
export { ForwardRef as ReactComponent };